import { SerializedToken, ERC20Token } from '@nominex/nomiswap-sdk'

export enum PoolCategory {
  'BOOSTING' = 'Boosting',
  'CORE' = 'Core',
  'BINANCE' = 'Binance', // Pools using native BNB behave differently than pools using a token
  'AUTO' = 'Auto',
}

interface PoolConfigBaseProps {
  sousId: number
  contractAddress: string
  migratorAddress: string
  launchpoolAddress: string
  poolCategory: PoolCategory
  sortOrder?: number
  harvest?: boolean
  isFinished?: boolean
  enableEmergencyWithdraw?: boolean
  isPromoPool?: boolean
  isPrivate?: boolean
  promoPeriodFinish?: number
}

export interface SerializedPoolConfig extends PoolConfigBaseProps {
  earningToken: SerializedToken
  stakingToken: SerializedToken
  isAutoVault?: boolean
}

export interface DeserializedPoolConfig extends PoolConfigBaseProps {
  earningToken: ERC20Token
  stakingToken: ERC20Token
}
